var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"download-control",on:{"click":function($event){return _vm.$emit('onClick')}}},[_c('FontAwesomeIcon',{attrs:{"icon":"cloud-download"}}),_c('span',[_vm._v(_vm._s(_vm.$t('Datei herunterladen')))])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }